import TranslationStore from "./TranslationStore";
import MyTibStore from "./MyTibStore";
import MyTimStore from "./MyTimStore";
import NotificationsStore from "./NotificationsStore";
import MouTeBeStore from "./MouTeBeStore";
import SictmStore from "./SictmStore";
import NextTravelStore from "./NextTravelStore";
import React from "react";

export const storesContext = React.createContext({
  myTibStore: new MyTibStore(),
  nextTravelStore: new NextTravelStore(),
  translationStore: new TranslationStore(),
  myTimStore: new MyTimStore(),
  notificationStore: new NotificationsStore(),
  moutebeStore: new MouTeBeStore(),
  sictmStore: new SictmStore(),
});
